/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LpDivorcePetitionMeta from "./LpDivorcePetitionMeta";
import Layout from "../../../../Layouts/Layout";
import Container from "../../../../../components/Container/Container";
import DivorceCheckin from "../../../../../components/Checkin/DivorceCheckin/DivorceCheckin";
import { landingPagesList } from "../../../../../services/landingPagesList";
import { getLastPathSplit } from "../../../../../services/redirect";
import ProcedureDivorceSection from "../../../../../components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import DivorcePlannerSection from "../../../../../components/Sections/Divorce/DivorcePlannerSection/DivorcePlannerSection";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import ServiceSection from "../../../../../components/Sections/Generic/ServiceSection/ServiceSection";
import TeamSection from "../../../../../components/Sections/Generic/TeamSection/TeamSection";
import BirdMapSection from "../../../../../components/Sections/Divorce/BirdMapSection/BirdMapSection";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import ServiceTeaser from "../../../../../components/Teaser/ServiceTeaser";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { divorceTeaserCards } from "../../../../../services/landingPageService";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";

const LpDivorcePetition = () => {
  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Online Scheidung";
  const headline = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Online Scheidung einfach & günstig";
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpDivorcePetitionMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Scheidungsantrag online stellen & professionelle Beratung erhalten."}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={divorceTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <DivorceCheckin idPrefix={"top"} checkinHeading={"Wir führen Sie Schritt für Schritt durch Ihre Scheidung"} />
          </Container>
        )}
        <ServiceTeaser />
      </GreyBackgroundWrapper>
      <DivorcePlannerSection />
      <ProcedureDivorceSection />
      <ServiceSection product={"divorce"} />
      <TeamSection isSubsection={true} />
      <GreyBackgroundWrapper>
        <BirdMapSection />
        <AdvantagesLegalbirdAttorneySection />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <DivorceCheckin idPrefix="bottom" />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
};

export default LpDivorcePetition;
